<script setup>
definePage({ meta: { ...PageMeta.Invoices.Add.Meta, pageTitle: 'New Invoice' } })

import InvoicesEditPage from '@/views/Previews/Invoices/InvoicesEditPage.vue'

/* ** */
</script>

<template>
  <InvoicesEditPage />
</template>
